export const succesfulCopyMsg = "Password Successfully Copied to ClipBoard 😄"
export const FailedCopyMsg = "Failed to Copy Password to ClipBoard 😭"
export const selectAtleastOneBox = "To generate password you must select atleast one checkbox 🧐"
export const passwordGenerated =  "Password is generated successfully  🤩"